export default __webpack_public_path__ + "static/media/apostles-walking-with-Jesus.a729b7e5.jpg";